/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import swiper (必要なモジュールのみ).
 */
import Swiper from "../lib/swiper";

// YouTube IframeAPI の読み込み
let tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
let firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// プレイヤーを保持するオブジェクト
let players = {};

/**
 * 共通スライダー
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const defaultSlider = () => {
	// 印刷時はスライダーを初期化しない
	if (window.matchMedia("print").matches) {
		return;
	}

	let sliderInstance = null;
	let thumbnailSlider = null;
	/**
	 * Setting - Thumbnail Slider
	 */
	const optionThumbail = {
		slidesPerView: 6,
		spaceBetween: 5,
		grabCursor: true,
		breakpoints: {
			761: {
				slidesPerView: 8,
				spaceBetween: 5,
			},
		},
	};
	thumbnailSlider = new Swiper(".slider-default-thumbnail", optionThumbail);

	const option = {
		loop: true,
		speed: 1000,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		// },
		navigation: {
			nextEl: ".slider-arrow-next",
			prevEl: ".slider-arrow-prev",
		},
		thumbs: {
			swiper: thumbnailSlider,
		},
	};

	sliderInstance = new Swiper(".slider-default", option);

	// 印刷前にスライダーを破棄
	window.addEventListener("beforeprint", () => {
		if (sliderInstance) {
			sliderInstance.destroy(true, true);
			sliderInstance = null;
		}
		if (thumbnailSlider) {
			thumbnailSlider.destroy(true, true);
			thumbnailSlider = null;
		}
	});

	// 印刷後にスライダーを再初期化
	window.addEventListener("afterprint", () => {
		if (!sliderInstance) {
			sliderInstance = new Swiper(".slider-default", option);
		}
		if (!thumbnailSlider) {
			thumbnailSlider = new Swiper(".slider-default-thumbnail", optionThumbail);
		}
	});
};

const mvSlider = () => {
	// if (window.matchMedia("(min-width: 600px)").matches) {
	// 	var centeredSlides = "false";
	// } else {
	// 	var centeredSlides = "ture";
	// }

	/**
	 * Setting - Thumbnail Slider - デフォルト
	 */
	const optionThumbnail = {
		loop: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		speed: 2000,
	};
	const sliderThumbnail = new Swiper(".slider-mv-parse", optionThumbnail);

	const option = {
		loop: true,
		parallax: true,
		speed: 2000,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		},
		thumbs: {
			swiper: sliderThumbnail,
		},
	};

	const slider = new Swiper(".slider-mv", option);
};

const fadeSlider = () => {
	/**
	 * Setting - Fade Slider - デフォルト
	 */
	const option = {
		loop: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		speed: 2000,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		},
	};

	/**
	 * Action - Fade Slider - デフォルト
	 */
	const slider = new Swiper(".slider-fade", option);
};

const thumbnailSlider = () => {
	const body = window.document.body;
	const classList = body.classList;

	if ([...classList].some((className) => className.startsWith("share-"))) {
		/**
		 * Setting - Thumbnail Slider
		 */
		const optionThumbail = {
			slidesPerView: 4,
			spaceBetween: 10,
			grabCursor: true,
			breakpoints: {
				761: {
					slidesPerView: 9,
					spaceBetween: 20,
				},
			},
		};

		const sliderThumbnail = new Swiper(".slider__thumbnail", optionThumbail);

		/**
		 * Setting - Main Slider
		 */
		const optionMain = {
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			speed: 1000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			// navigation: {
			// 	nextEl: ".swiper-button-next",
			// 	prevEl: ".swiper-button-prev",
			// },
			thumbs: {
				swiper: sliderThumbnail,
			},
		};

		const sliderThumbnailMain = new Swiper(".slider__thumbnail__main", optionMain);
	}
};

const carouselSlider = () => {
	/**
	 * Setting - Carousel Slider - デフォルト
	 */
	const option = {
		slidesPerView: 2,
		spaceBetween: 5,
		centeredSlides: true,
		loop: true,
		speed: 1500,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
			// disableOnInteraction: false,
		},
		breakpoints: {
			// スライドの表示枚数：500px以上の場合
			640: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			760: {
				slidesPerView: 4,
				spaceBetween: 10,
			},
			1441: {
				slidesPerView: 6,
				spaceBetween: 10,
			},
		},
		// pagination: {
		// 	el: ".swiper-pagination",
		// 	clickable: true,
		// },
	};

	/**
	 * Action - Carousel Slider - デフォルト
	 */
	const sliderCarousel = new Swiper(".slider-carousel", option);
};

const postSlider = () => {
	// 印刷時はスライダーを初期化しない
	if (window.matchMedia("print").matches) {
		return;
	}

	const sliderInstances = [];

	/**
	 * Setting - post Slider - デフォルト（gallery / sale / blog 等）
	 */
	const option = {
		slidesPerView: 2,
		spaceBetween: 15,
		loop: true,
		speed: 1000,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		navigation: {
			nextEl: ".slider-arrow-next",
			prevEl: ".slider-arrow-prev",
		},
		breakpoints: {
			960: {
				slidesPerView: 3,
				spaceBetween: 60,
			},
			760: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	};

	/**
	 * Setting - トップイベント専用
	 * - 自動スライド OFF
	 * - SP は1件表示
	 */
	const optionEvent = {
		slidesPerView: 1,
		spaceBetween: 15,
		loop: true,
		speed: 1000,
		autoplay: false,
		navigation: {
			nextEl: ".slider-arrow-next",
			prevEl: ".slider-arrow-prev",
		},
		breakpoints: {
			960: {
				slidesPerView: 3,
				spaceBetween: 60,
			},
			760: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	};

	document.querySelectorAll(".slider-post").forEach((el) => {
		const isEvent = el.classList.contains("slider-post--event");
		const baseOption = isEvent ? optionEvent : option;
		const instance = new Swiper(el, {
			...baseOption,
			navigation: {
				nextEl: el.querySelector(".slider-arrow-next"),
				prevEl: el.querySelector(".slider-arrow-prev"),
			},
		});
		sliderInstances.push(instance);
	});

	// 印刷前にスライダーを破棄
	window.addEventListener("beforeprint", () => {
		sliderInstances.forEach((instance) => {
			if (instance) {
				instance.destroy(true, true);
			}
		});
		sliderInstances.length = 0;
	});

	// 印刷後にスライダーを再初期化
	window.addEventListener("afterprint", () => {
		if (sliderInstances.length === 0) {
			document.querySelectorAll(".slider-post").forEach((el) => {
				const isEvent = el.classList.contains("slider-post--event");
				const baseOption = isEvent ? optionEvent : option;
				sliderInstances.push(
					new Swiper(el, {
						...baseOption,
						navigation: {
							nextEl: el.querySelector(".slider-arrow-next"),
							prevEl: el.querySelector(".slider-arrow-prev"),
						},
					})
				);
			});
		}
	});
};

const modelhouseSlider = () => {
	const optionModelhouse = {
		slidesPerView: 2,
		spaceBetween: 0,
		loop: true,
		speed: 1000,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		navigation: {
			nextEl: ".slider-arrow-next",
			prevEl: ".slider-arrow-prev",
		},
		breakpoints: {
			960: {
				slidesPerView: 3,
			},
			760: {
				slidesPerView: 3,
			},
		},
	};
	new Swiper(".slider-modelhouse", optionModelhouse);
};

/**
 * Life&co. Model House スライダー
 */
const lifecoModelSlider = () => {
	const el = document.querySelector(".slider-lifeco-model");
	if (!el) {
		return;
	}

	const dots = el.querySelectorAll(".p-lifeco-model__dot");
	const slideCount = dots.length;

	const updateDots = (realIndex) => {
		dots.forEach((dot, i) => {
			const isActive = i === realIndex;
			dot.classList.toggle("is-active", isActive);
			dot.setAttribute("aria-selected", isActive ? "true" : "false");
		});
	};

	const swiper = new Swiper(el, {
		slidesPerView: "auto",
		spaceBetween: 20,
		speed: 800,
		grabCursor: true,
		loop: true,
		loopedSlides: slideCount,
		breakpoints: {
			761: {
				spaceBetween: 40,
			},
			960: {
				spaceBetween: 50,
			},
		},
		on: {
			slideChange(instance) {
				updateDots(instance.realIndex);
			},
		},
	});

	dots.forEach((dot) => {
		dot.addEventListener("click", () => {
			swiper.slideToLoop(Number(dot.dataset.index));
		});
	});
};

const conceptThumbnailSlider = () => {
	/**
	 * Setting - Thumbnail Slider
	 */
	const optionThumbail = {
		slidesPerView: 4,
		spaceBetween: 10,
		grabCursor: true,
		breakpoints: {
			761: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
		},
	};

	const thumbnailElements = document.querySelectorAll(".slider__thumbnail");
	const mainElements = document.querySelectorAll(".slider__thumbnail__concept");

	thumbnailElements.forEach((el, index) => {
		const thumbnailSlider = new Swiper(el, optionThumbail);

		/**
		 * Setting - Main Slider
		 */
		const optionMain = {
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			speed: 1000,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: mainElements[index].querySelector(".slider-arrow-next"),
				prevEl: mainElements[index].querySelector(".slider-arrow-prev"),
			},
			thumbs: {
				swiper: thumbnailSlider,
			},
		};

		if (mainElements[index]) {
			new Swiper(mainElements[index], optionMain);
		}
	});
};

function getMovieSwiper() {
	const sliderEl = document.querySelector(".movie-slider");
	return sliderEl && sliderEl.swiper ? sliderEl.swiper : null;
}

function stopMovieAutoplay() {
	const swiperInstance = getMovieSwiper();
	if (swiperInstance && swiperInstance.autoplay) {
		swiperInstance.autoplay.stop();
	}
}

function startMovieAutoplay() {
	const swiperInstance = getMovieSwiper();
	if (swiperInstance && swiperInstance.autoplay) {
		swiperInstance.autoplay.start();
	}
}

// モーダルの制御（共有 dialog は Swiper 外に置く）
function setupModalControls() {
	const dialog = document.querySelector("#movie-gallery-modal");
	const sliderEl = document.querySelector(".movie-slider");
	if (!dialog || !sliderEl || dialog.dataset.modalBound === "1") return;

	dialog.dataset.modalBound = "1";

	const closeButton = dialog.querySelector(".close-modal");

	sliderEl.addEventListener("click", (e) => {
		const showButton = e.target.closest(".link");
		if (!showButton || !sliderEl.contains(showButton)) return;

		e.preventDefault();
		const youtubeId = showButton.dataset.youtubeId;
		if (!youtubeId) return;

		const container = dialog.querySelector(".youtube-container");
		if (container) {
			container.dataset.youtubeId = youtubeId;
		}

		if (typeof dialog.showModal === "function") {
			dialog.showModal();
		} else {
			dialog.setAttribute("open", "open");
		}
		initializeVideo(dialog);
	});

	if (closeButton) {
		closeButton.addEventListener("click", (e) => {
			e.preventDefault();
			stopVideo(dialog);
			if (typeof dialog.close === "function") {
				dialog.close();
			} else {
				dialog.removeAttribute("open");
			}
		});
	}

	dialog.addEventListener("close", () => {
		stopVideo(dialog);
	});
}

// 動画の初期化
function initializeVideo(dialog) {
	const container = dialog.querySelector(".youtube-container");
	if (!container) return;

	const youtubeId = container.dataset.youtubeId;
	if (!youtubeId) return;

	if (players[youtubeId] && typeof players[youtubeId].destroy === "function") {
		players[youtubeId].destroy();
		delete players[youtubeId];
	}

	container.innerHTML = "";

	const iframe = document.createElement("iframe");
	iframe.width = "438";
	iframe.height = "778";
	iframe.src = `https://www.youtube.com/embed/${youtubeId}?enablejsapi=1&autoplay=1&mute=1&loop=1&playlist=${youtubeId}&playsinline=1&origin=${window.location.origin}`;
	iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
	iframe.allowFullscreen = true;
	container.appendChild(iframe);

	if (typeof YT === "undefined" || typeof YT.Player !== "function") {
		stopMovieAutoplay();
		return;
	}

	players[youtubeId] = new YT.Player(iframe, {
		events: {
			onReady: (event) => {
				event.target.playVideo();
				stopMovieAutoplay();
			},
			onStateChange: (event) => {
				if (event.data === YT.PlayerState.ENDED) {
					startMovieAutoplay();
				}
			},
			onError: (event) => {
				console.error("YouTube Player Error:", event.data);
				startMovieAutoplay();
			},
		},
	});
}

// 動画の停止
function stopVideo(dialog) {
	const container = dialog.querySelector(".youtube-container");
	if (!container) return;

	const youtubeId = container.dataset.youtubeId;
	if (youtubeId && players[youtubeId]) {
		if (typeof players[youtubeId].stopVideo === "function") {
			players[youtubeId].stopVideo();
		}
		if (typeof players[youtubeId].destroy === "function") {
			players[youtubeId].destroy();
		}
		delete players[youtubeId];
	}

	container.innerHTML = "";
	delete container.dataset.youtubeId;
	startMovieAutoplay();
}

const movieSlider = () => {
	const originalSlides = document.querySelectorAll(".movie-slider .swiper-slide");
	if (!originalSlides.length) return;

	const slideCount = originalSlides.length;

	const movieSwiper = new Swiper(".movie-slider", {
		slidesPerView: 1.5,
		spaceBetween: 5,
		centeredSlides: true,
		loop: slideCount > 1,
		loopedSlides: slideCount,
		loopAdditionalSlides: Math.max(slideCount, 4),
		speed: 1500,
		watchOverflow: true,
		resistanceRatio: 0.65,
		touchStartPreventDefault: false,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
		breakpoints: {
			640: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			760: {
				slidesPerView: 4,
				spaceBetween: 10,
			},
			1441: {
				slidesPerView: 6,
				spaceBetween: 10,
			},
		},
		on: {
			init: function () {
				setTimeout(() => {
					this.update();
				}, 0);
			},
			slideChange: function () {
				document.querySelectorAll(".movie-slide").forEach((slide) => {
					slide.classList.remove("current");
				});
				const activeSlide = this.slides[this.activeIndex];
				if (activeSlide) {
					activeSlide.classList.add("current");
				}
			},
		},
	});

	setupModalControls();

	const sliderEl = document.querySelector(".movie-slider");
	if (sliderEl) {
		sliderEl.addEventListener("mouseenter", () => {
			movieSwiper.autoplay.stop();
		});

		sliderEl.addEventListener("mouseleave", () => {
			movieSwiper.autoplay.start();
		});
	}
};

// YouTube APIの読み込み完了時の処理
window.onYouTubeIframeAPIReady = function () {
	// プレイヤー生成はモーダル開時に行う（二重バインド防止のためここでは何もしない）
};

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: set */

const setSlider = () => {
	defaultSlider();
	mvSlider();
	fadeSlider();
	thumbnailSlider();
	carouselSlider();
	postSlider();
	conceptThumbnailSlider();
	movieSlider(); // ムービースライダーを追加
	modelhouseSlider(); // モデルハウススライダーを追加
	lifecoModelSlider(); // Life&co. モデルハウススライダー
};
export { setSlider };
